import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ConfigurableService } from "../../types/common";
import { getListConfigurableService } from "../../methods/Methods";

export interface ConfigurableServiceState {
    dataList: ConfigurableService[];
}

//-------------------------------------------------------------------------------------------------- Vars and consts
const configurableServiceInitialState: ConfigurableServiceState = {
    dataList: [],
};


const fillDataServiceSlice = createAsyncThunk(
    "thunk/configurableService",
    async () => {
        let data = [] as ConfigurableService[];
        await getListConfigurableService().then((response) => {
            if (response && response.data.data) {
                data = response.data.data;
            }
        }).catch(() => { });

        return data;
    }
);

const configurableServiceSlice = createSlice({
  name: "configurableService",
  initialState: configurableServiceInitialState,
  reducers: {
    clearConfigurableServiceData: (state) => {
      state.dataList = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fillDataServiceSlice.fulfilled, (state, action: PayloadAction<ConfigurableService[]>) => {
      state.dataList = action.payload;
    });
  },
});

export { fillDataServiceSlice };

export const { clearConfigurableServiceData } = configurableServiceSlice.actions;

export const getConfigurableServiceState = (state: any): ConfigurableServiceState =>
  state.configurableService;

export default configurableServiceSlice.reducer;